import type { AlbumCaseInterface } from './album-case.interface';
import type { KeywordInterface } from './keyword.interface';
import type { SerieInterface } from './serie.interface';
import type { PatientInterface } from './patient.interface';
import type { ShareRoleInterface } from './album.interface';
import { SccStudyDataInterface } from '../../scc/shared/services/scc-study-data.interface';

export interface Study {
  id: number;
  clinicId?: number;
  publicId: string;
  createdAt: Date | string;
  date?: Date | string;
  keywords: KeywordInterface[];
  modalityTypeValues: string[];
  nbInstances: number;
  nbReports: number;
  nbAttachments: number;
  ownerName?: string;
  patient?: PatientInterface;
  patientId?: number;
  patientName?: string;
  patientSex?: string;
  patientSterilisation?: string;
  petName?: string;
  previewPublicId?: string;
  previewHash?: string;
  previewUri?: string; // not used anymore but in mock
  speciesName?: string;
  studyStatus: EStudyStatus;
  myPacsAction?: EStudyAction;
  cases?: AlbumCaseInterface[];
  name?: string;
  description?: string;
  orthancInstanceUid?: string;
  series?: SerieInterface[];
  shareUserIds?: number[];
  examDate?: Date | string;
  lastReportId?: number;
  clinicName?: string;
  clinicAddress?: string;
  clinicPhone?: string;
  isAlbum?: boolean;
  shareRoles?: ShareRoleInterface[];
  hasShares?: boolean;
  scc?: SccStudyDataInterface;
}

export enum EStudyStatus {
  New = 'NEW',
  Uploading = 'UPLOADING',
  Stable = 'STABLE',
  Canceled = 'CANCELED',
  Removed = 'REMOVED'
}

export enum EStudyAction {
  Clone = 'CLONE',
  Anonymize = 'ANONYMIZE',
  Dicomizer = 'DICOMIZER',
  Upload = 'UPLOAD',
}
